<div c-select-doctype-view class="child sub-view">
    <div class="content solo">
        <section class="child">
            <div c-toggle="viewVisible" c-toggle-options="{type: 'fade'}">
                <h1>{{"contentType.header"|translate}}</h1>
                <div c-select-list toggle="0" items="contentTypes" selected-item="selectedContentType" validation="validation"></div>
                <div class="warning" ng-if="!contentTypes.length" ng-bind-html="'workflowConfigs.none'|translate"></div>
            </div>
        </section>
    </div>
</div>

